import { DeferredEventsClient } from './DeferredEventsClient';
export class YandexMetricaClient extends DeferredEventsClient {
    constructor(id, nonceId) {
        super();
        this.initialized = false;
        this.initialize = () => {
            if (this.id && !this.initialized) {
                const script = document.createElement('script');
                script.async = true;
                this.nonceId && (script.nonce = this.nonceId);
                script.innerHTML = `(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
  m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
  (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

  ym(${this.id}, "init", { clickmap:true, trackLinks:true, accurateTrackBounce:true, webvisor:true, triggerEvent:true });`;
                document.head.appendChild(script);
                this.initialized = true;
                this.sendDeferredEvents(this.sendEvent);
            }
        };
        this.generateReachGoalName = ({ category, entity, action }, meta = {}) => {
            let res = `${category}_${entity}_${action}`;
            let level = 1;
            while (true) {
                if (meta[`param${level}`]) {
                    res += `_${meta[`param${level}`]}`;
                }
                else {
                    break;
                }
                level++;
            }
            return res.replaceAll('/', '-');
        };
        this.sendEvent = ({ category, entity, action }, meta) => {
            if (this.initialized && this.id) {
                ym(this.id, 'reachGoal', this.generateReachGoalName({ category, entity, action }, meta), {
                    [category]: {
                        [entity]: {
                            [action]: Object.assign(Object.assign(Object.assign({}, this.generateDeepMeta(meta)), meta), { param1: undefined, param2: undefined, param3: undefined, param4: undefined, param5: undefined, param6: undefined, param7: undefined, value: undefined }),
                        },
                    },
                    order_price: meta === null || meta === void 0 ? void 0 : meta.value,
                });
            }
            else {
                this.deferEvent({ category, entity, action }, meta);
            }
        };
        this.pageVisited = () => {
            if (this.initialized && this.id) {
                ym(this.id, 'hit', window.location.pathname);
            }
        };
        this.id = id;
        this.nonceId = nonceId;
    }
    generateDeepMeta(meta = {}, level = 1) {
        if (meta[`param${level + 1}`]) {
            return {
                [meta[`param${level}`]]: this.generateDeepMeta(meta, level + 1),
            };
        }
        else if (meta[`param${level}`]) {
            return {
                [meta[`param${level}`]]: {},
            };
        }
        return {};
    }
}
